import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_upload",
  "use": "icon-map_upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_upload\">\n<g id=\"icon-map_upload_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 2 6 C 4 5.511719 5 5.046875 7 4 L 7 13 L 9 13 L 9 4 C 10.855469 5.046875 11.945313 5.511719 14 6 C 9.816406 0.277344 6.183594 0.277344 2 6 M 0 9 C 0 19.191406 15.878906 19.191406 16 9 L 15 9 C 11.21875 16.769531 4.6875 14.171875 0 9 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_upload.svg
// module id = GPY0
// module chunks = 24